import React from 'react';
import { Route, Switch } from 'react-router-dom';
import VideoJsPlayer from '../Views/VideoJsPlayer';

export default class AppRoutes extends React.Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div className="main-container">
                <Switch>
                    <Route exact path="/" component={VideoJsPlayer} />
                </Switch>
            </div>)
    }
}
